import { Charts } from './Charts';
import IdentificationChartsDataProvider from './contexts/IdentificationChartsDataContext';

const IdentificationWrapper = () => {
    return (
        <IdentificationChartsDataProvider>
            <Charts />
        </IdentificationChartsDataProvider>
    );
};

export default IdentificationWrapper;
